import { type IPublicCasesQuery } from 'application/querySchemas/IPublicCasesQuery';
import { type IPublicCasesClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IPublicCasesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class PublicCasesQuery implements IPublicCasesQuery {
    constructor(
        @inject('IPublicCasesClient')
        public readonly publicCaseClient: IPublicCasesClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.publicCaseClient.get({});
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
